import { EventPayload } from "../../../common/types/Event";

// ShiftCancelled events for frontend
export type WorkOffersTalentAmountChangedEvent = EventPayload<{
  amount: number;
}> & {
  name: "workOffTlntAmntUpd";
};

export type OrderRowBundleTaskSpecChangedEvent = EventPayload<{
  taskSpec: { amount: number };
}> & {
  name: "ordRowBndlTskSpecChg";
};

export type OrderRowEditReasonChangedEvent = EventPayload<{
  editReason: string;
  editUser?: string;
  editTime: number;
}> & {
  name: "ordRowEdtRsnChg";
};

export type OrderRowBundleCancelledEvent = EventPayload<{
  orderRowIds: string[];
  reasonForCancellation: string;
}> & {
  name: "ordRowBndlCancl";
};

export type ShiftCancelledEvent =
  | WorkOffersTalentAmountChangedEvent
  | OrderRowBundleTaskSpecChangedEvent
  | OrderRowEditReasonChangedEvent
  | OrderRowBundleCancelledEvent;

export const isWorkOffersTalentAmountChangedEvent = (
  event: EventPayload<unknown>,
): event is WorkOffersTalentAmountChangedEvent =>
  event.name === "workOffTlntAmntUpd";

export const isOrderRowBundleTaskSpecChangedEvent = (
  event: EventPayload<unknown>,
): event is OrderRowBundleTaskSpecChangedEvent =>
  event.name === "ordRowBndlTskSpecChg";

export const isOrderRowEditReasonChangedEvent = (
  event: EventPayload<unknown>,
): event is OrderRowEditReasonChangedEvent =>
  event.name === "ordRowEdtRsnChg";

export const isOrderRowBundleCancelledEvent = (
  event: EventPayload<unknown>,
): event is OrderRowBundleCancelledEvent =>
  event.name === "ordRowBndlCancl";
